const lotteryMap = {
  AULUCKY10: {
    template: "PK10",
    name: "澳洲幸运10",
    suffix: ""
  },
  AULUCKY20: {
    template: "KL8",
    name: "澳洲幸运20",
    suffix: ""
  },
  AULUCKY5: {
    template: "SSC",
    name: "澳洲幸运5",
    suffix: ""
  },
  AULUCKY8: {
    template: "KLSF",
    name: "澳洲幸运8",
    suffix: ""
  },
  KL8: {
    template: "KL8",
    name: "北京快乐8",
    suffix: ""
  },
  BJKL8: {
    template: "KL8",
    name: "北京快乐8",
    suffix: ""
  },
  BJPK10: {
    template: "PK10",
    name: "北京赛车",
    suffix: ""
  },
  BJPK10BJL: {
    template: "PK10BJL",
    name: "极速百家乐",
    suffix: ""
  },
  CQSSC: {
    template: "SSC",
    name: "重庆时时彩",
    suffix: ""
  },
  F3D: {
    template: "3D",
    name: "福彩3D",
    suffix: ""
  },
  GD11X5: {
    template: "11X5",
    name: "广东11选5",
    suffix: ""
  },
  GDKLSF: {
    template: "KLSF",
    name: "广东快乐十分",
    suffix: ""
  },
  GXK3: {
    template: "K3",
    name: "广西快3",
    suffix: ""
  },
  GXKLSF: {
    template: "GXKLSF",
    name: "广西快乐十分",
    suffix: ""
  },
  HK6: {
    template: "HK6",
    name: "香港六合彩",
    suffix: ""
  },
  JLK3: {
    template: "K3",
    name: "吉林快3",
    suffix: ""
  },
  PCEGG: {
    template: "PCEGG",
    name: "PC蛋蛋",
    suffix: ""
  },
  PK10JSC: {
    template: "PK10",
    name: "极速赛车",
    suffix: ""
  },
  PL3: {
    template: "3D",
    name: "体彩排列3",
    suffix: ""
  },
  SSCJSC: {
    template: "SSC",
    name: "极速时时彩",
    suffix: ""
  },
  TJSSC: {
    template: "SSC",
    name: "天津时时彩",
    suffix: ""
  },
  XJSSC: {
    template: "SSC",
    name: "新疆时时彩",
    suffix: ""
  },
  TXFFC: {
    template: "SSC",
    name: "腾讯分分彩",
    suffix: ""
  },
  XYNC: {
    template: "KLSF",
    name: "重庆幸运农场",
    suffix: ""
  },
  LUCKYSB: {
    template: "PK10",
    name: "极速飞艇",
    suffix: ""
  },
  HK6JSC: {
    template: "HK6",
    name: "极速六合彩",
    suffix: ""
  },
  K3JSC: {
    template: "K3",
    name: "极速快3",
    suffix: ""
  },
  KLSFJSC: {
    template: "KLSF",
    name: "极速快乐十分",
    suffix: ""
  },
  KL8JSC: {
    template: "KL8",
    name: "极速快乐8",
    suffix: ""
  },
  "11X5JSC": {
    template: "11X5",
    name: "极速11选5",
    suffix: ""
  },
  PK10JSCNN: {
    template: "PK10JSCNN",
    name: "极速牛牛",
    suffix: "(简约)"
  },
  PK10JSCNN_A: {
    template: "PK10JSCNN",
    name: "极速牛牛",
    suffix: "(娱乐)"
  }
};

// console.log(Object.keys(lotteryMap).length);


const gameTypeObject = {
  LUCKYSB: { type: 'JSC' },
  SSCJSC: { type: 'JSC' },
  TXFFC: { type: 'JSC' },
  PK10JSC: { type: 'JSC' },
  HK6JSC: { type: 'JSC' },
  KLSFJSC: { type: 'JSC' },
  K3JSC: { type: 'JSC' },
  '11X5JSC': { type: 'JSC' },
  KL8JSC: { type: 'JSC' },
  PK10JSCNN: { type: 'JSC' },
  CQSSC: { type: 'SSC' },
  TJSSC: { type: 'SSC' },
  XJSSC: { type: 'SSC' },
  AULUCKY5: { type: 'KKC' },
  AULUCKY8: { type: 'KKC' },
  AULUCKY10: { type: 'KKC' },
  AULUCKY20: { type: 'KKC' },
  XYNC: { type: 'KKC' },
  GDKLSF: { type: 'KKC' },
  GXK3: { type: 'KKC' },
  PCEGG: { type: 'KKC' },
  BJKL8: { type: 'KKC' },
  JLK3: { type: 'KKC' },
  GXKLSF: { type: 'KKC' },
  GD11X5: { type: 'KKC' },
  BJPK10: { type: 'KKC' },
  HK6: { type: 'HKC' },
  F3D: { type: 'QGC' },
  PL3: { type: 'QGC' },
  PK10JSCNN_A: { type: 'YLC' },
  BJPK10BJL: { type: 'YLC' }
}